import { render, staticRenderFns } from "./DashboardNew.vue?vue&type=template&id=4adc1485&scoped=true&"
var script = {}
import style0 from "./DashboardNew.vue?vue&type=style&index=0&id=4adc1485&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adc1485",
  null
  
)

export default component.exports